import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Button, Grid, ListItem, Typography, Tooltip, withStyles } from '@material-ui/core'
import { EditableInput, EditableSwitch } from '../common/EditableComponents'
import { ColorSwatch, EditableColorPicker } from '../common/ColorPicker'
import AddShop from './AddShop'
import {
  updateDCHSettings,
  deleteDCHSettings,
  getDCHSettingsByCompanyId,
  createDCHCredentials,
  checkDCHApiKey,
  getDCHRenewToken,
  getDCHCredentialByShopId,
  updateDCHCredentials,
  setWmDispatchCretendial,
} from '../../actions/dispatch'
import ModalDialog from '../common/ModalDialog'
import { withRouter } from 'react-router-dom'
import InfoIcon from '@material-ui/icons/Info'
import { toLocalDate } from '../../utils/common'

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 300,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip)

function tooltipWmDispatch(message) {
  return (
    <HtmlTooltip
      placement="top-start"
      title={
        <React.Fragment>
          <Typography color="inherit">{message}</Typography>
        </React.Fragment>
      }
    >
      <InfoIcon style={{ color: '#03a9f4' }} />
    </HtmlTooltip>
  )
}

function SwitchSettings(props) {
  const { title, editMode, settingValue, settingName } = props

  return (
    <ListItem>
      <Grid container>
        <Grid className="labelField txt-bold" item xs={12} sm={8} md={8} lg={8}>
          <Typography>{title}</Typography>
        </Grid>
        <Grid className="editField" item xs={12} sm={4} md={4} lg={4}>
          <Typography>
            <EditableSwitch
              checked={settingValue}
              onChange={props.onChange(settingName, settingValue)}
              valueToRender={settingValue ? 'Enabled' : 'Disabled'}
              editMode={editMode}
            />
          </Typography>
        </Grid>
      </Grid>
    </ListItem>
  )
}

class WmDispatchShopInfoSettings extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      editMode: false,
      editModeApiKey: false,
      currentStoreKey: (this.props.shopCredential && this.props.shopCredential.apiKey) || '',
      currentAccessToken:
        (this.props.shopCredential && this.props.shopCredential.accessToken) || '',
      currentExpirationDate:
        (this.props.shopCredential && this.props.shopCredential.expirationDate) || '',
      enableStatus:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enabled) ||
        false,
      enableAllEmptyOrders:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableAllowEmptyOrders) ||
        false,
      enable2WayAssignment:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableTwoWayAssignment) ||
        false,
      enable2WayUpdateSchedule:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableTwoWayUpdateSchedule) ||
        false,
      enable2WaySendtoUnassign:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableTwoWayRevert) ||
        false,
      enable2WayAutopack:
        (this.props.shopDispatch && this.props.shopDispatch.wmDispatchSettings.enableTwoAutoPack) ||
        false,
      enableUnassignedOrder:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableUnAssignedOrder) ||
        false,
      colorSameDay:
        this.props.shopDispatch &&
        this.props.shopDispatch.wmDispatchSettings &&
        this.props.shopDispatch.wmDispatchSettings.colorSameDay != ''
          ? this.props.shopDispatch.wmDispatchSettings.colorSameDay
          : '#E89623',
      colorNextDay:
        this.props.shopDispatch &&
        this.props.shopDispatch.wmDispatchSettings &&
        this.props.shopDispatch.wmDispatchSettings.colorNextDay != ''
          ? this.props.shopDispatch.wmDispatchSettings.colorNextDay
          : '#9500DB',
      colorBeyondNextDay:
        this.props.shopDispatch &&
        this.props.shopDispatch.wmDispatchSettings &&
        this.props.shopDispatch.wmDispatchSettings.colorBeyondNextDay != ''
          ? this.props.shopDispatch.wmDispatchSettings.colorBeyondNextDay
          : '#1cc4e8',
      generateNewToken:
        this.props.shopCredential == null || this.props.shopCredential.accessToken == null || false,
      changedApiKey: false,
      enableTwoWay:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableTwoWay) ||
        false,
      enabledColoredPins:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enabledColoredPins) ||
        false,
      enabledScheduledColoredPins:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enabledScheduledColoredPins) ||
        false,
      enableSubTotal:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableSubTotal) ||
        false,
      enableApplicableDiscountAmount:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableApplicableDiscountAmount) ||
        false,
      enableApplicableExciseTaxes:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableApplicableExciseTaxes) ||
        false,
      enableTotalTaxORGranularTax:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableTotalTaxORGranularTax) ||
        false,
      enableApplicablePromotionsName:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableApplicablePromotionsName) ||
        false,
      enableApplicableRewardsName:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableApplicableRewardsName) ||
        false,
      enableApplicableOrderTags:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableApplicableOrderTags) ||
        false,
      enablePaidStatus:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enablePaidStatus) ||
        false,
      enableProductName:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableProductName) ||
        false,
      enableBrand:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableBrand) ||
        false,
      enableProductsValue:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableProductsValue) ||
        false,
      enableDiscount:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableDiscount) ||
        false,
      enableDiscountNotes:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableDiscountNotes) ||
        false,
      enableWPU:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableWPU) ||
        false,
      enableProductSKU:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableProductSKU) ||
        false,
      enableBatchUID:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableBatchUID) ||
        false,
      enableBatchTrackingSystemLabel:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableBatchTrackingSystemLabel) ||
        false,
      enableMemberId:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableMemberId) ||
        false,
      enableMemberGroup:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableMemberGroup) ||
        false,
      enableMemberTags:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableMemberTags) ||
        false,
      enableConsumerType:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableConsumerType) ||
        false,
      enableDOB:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableDOB) ||
        false,
      enableJoinedDate:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableJoinedDate) ||
        false,
      enableLastVisitDate:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableLastVisitDate) ||
        false,
      enableNumberOfCompletedTransactions:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableNumberOfCompletedTransactions) ||
        false,
      enableTotalLoyaltyPoints:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableTotalLoyaltyPoints) ||
        false,
      enableEstimatedPointsEarnedOnOrder:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableEstimatedPointsEarnedOnOrder) ||
        false,
    }
  }

  componentDidUpdate(previousProps) {
    if (previousProps.shopDispatch !== this.props.shopDispatch) {
      this.setState({
        enableStatus:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enabled) ||
          false,
        enableAllEmptyOrders:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableAllowEmptyOrders) ||
          false,
        enable2WayAssignment:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableTwoWayAssignment) ||
          false,
        enable2WayUpdateSchedule:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableTwoWayUpdateSchedule) ||
          false,
        enable2WaySendtoUnassign:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableTwoWayRevert) ||
          false,
        enable2WayAutopack:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings.enableTwoAutoPack) ||
          false,
        enableUnassignedOrder:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableUnAssignedOrder) ||
          false,
        colorSameDay:
          this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.colorSameDay != ''
            ? this.props.shopDispatch.wmDispatchSettings.colorSameDay
            : '#E89623',
        colorNextDay:
          this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.colorNextDay != ''
            ? this.props.shopDispatch.wmDispatchSettings.colorNextDay
            : '#9500DB',
        colorBeyondNextDay:
          this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.colorBeyondNextDay != ''
            ? this.props.shopDispatch.wmDispatchSettings.colorBeyondNextDay
            : '#1cc4e8',
        enableTwoWay:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableTwoWay) ||
          false,
        enabledColoredPins:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enabledColoredPins) ||
          false,
        enabledScheduledColoredPins:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enabledScheduledColoredPins) ||
          false,
        enableSubTotal:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableSubTotal) ||
          false,
        enableApplicableDiscountAmount:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableApplicableDiscountAmount) ||
          false,
        enableApplicableExciseTaxes:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableApplicableExciseTaxes) ||
          false,
        enableTotalTaxORGranularTax:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableTotalTaxORGranularTax) ||
          false,
        enableApplicablePromotionsName:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableApplicablePromotionsName) ||
          false,
        enableApplicableRewardsName:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableApplicableRewardsName) ||
          false,
        enableApplicableOrderTags:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableApplicableOrderTags) ||
          false,
        enablePaidStatus:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enablePaidStatus) ||
          false,
        enableProductName:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableProductName) ||
          false,
        enableBrand:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableBrand) ||
          false,
        enableProductsValue:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableProductsValue) ||
          false,
        enableDiscount:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableDiscount) ||
          false,
        enableDiscountNotes:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableDiscountNotes) ||
          false,
        enableWPU:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableWPU) ||
          false,
        enableProductSKU:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableProductSKU) ||
          false,
        enableBatchUID:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableBatchUID) ||
          false,
        enableBatchTrackingSystemLabel:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableBatchTrackingSystemLabel) ||
          false,
        enableMemberId:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableMemberId) ||
          false,
        enableMemberGroup:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableMemberGroup) ||
          false,
        enableMemberTags:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableMemberTags) ||
          false,
        enableConsumerType:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableConsumerType) ||
          false,
        enableDOB:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableDOB) ||
          false,
        enableJoinedDate:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableJoinedDate) ||
          false,
        enableLastVisitDate:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableLastVisitDate) ||
          false,
        enableNumberOfCompletedTransactions:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableNumberOfCompletedTransactions) ||
          false,
        enableTotalLoyaltyPoints:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableTotalLoyaltyPoints) ||
          false,
        enableEstimatedPointsEarnedOnOrder:
          (this.props.shopDispatch &&
            this.props.shopDispatch.wmDispatchSettings &&
            this.props.shopDispatch.wmDispatchSettings.enableEstimatedPointsEarnedOnOrder) ||
          false,
      })
    }

    if (previousProps.shopCredential !== this.props.shopCredential) {
      this.setState({
        currentStoreKey: (this.props.shopCredential && this.props.shopCredential.apiKey) || '',
        currentAccessToken:
          (this.props.shopCredential && this.props.shopCredential.accessToken) || '',
        currentExpirationDate:
          (this.props.shopCredential && this.props.shopCredential.expirationDate) || '',
        generateNewToken:
          this.props.shopCredential == null ||
          this.props.shopCredential.accessToken == null ||
          false,
      })
    }
  }

  onChange = (key, value, isSelect) => (e) => {
    if (isSelect) {
      this.setState({ [key]: e.target.value })
    } else {
      this.setState({ [key]: !value })
    }
  }

  deleteIntegration = (shopDispatch) => {
    if (shopDispatch !== null) {
      const request = {
        companyId: shopDispatch.companyId,
        shopId: shopDispatch.shopId,
      }
      this.props.dispatch(deleteDCHSettings({ request })).then((res) => {
        this.props.history.push(`/settings/integration/wmDispatch`)
      })
    }
  }

  openDeleteShopModal = () => {
    this.shopDeleteModal.handleClickOpen()
  }

  onChangeColor = (key) => (color) => {
    this.setState({ [key]: color.hex })
  }

  onChangeApiKey = (key, value) => {
    this.setState({ [key]: value.target.value })
    this.setState({ changedApiKey: true })
  }

  resetApiKeyFlags = () => {
    this.setState({ changedApiKey: false })
  }

  checkApiKey = () => {
    const { currentStoreKey } = this.state
    const { shopDispatch = {} } = this.props

    if (currentStoreKey == '' || /^( )*$/.test(currentStoreKey)) {
      this.props.onError('API key value must not be empty')
      return
    }

    if (shopDispatch && shopDispatch.companyId && shopDispatch.shopId) {
      const request = {
        companyId: shopDispatch.companyId,
        shopId: shopDispatch.shopId,
        apiKey: currentStoreKey,
      }
      //mcs - Validate API key
      this.props.dispatch(checkDCHApiKey({ provider: 'wmDispatch', request })).then((res) => {
        if (res) {
          //update generateNewToken and currentAccessToken (update with new accessToken)
          if (res.accessToken == null) {
            this.setState({ generateNewToken: true })
            this.props.onSuccess(
              "You haven't created a token with this API key. Please generate one",
            )
          } else {
            this.props.dispatch(setWmDispatchCretendial(res))
            this.setState({
              generateNewToken: false,
              currentAccessToken: res.accessToken,
              currentExpirationDate: res.expirationDate,
            })
            this.props.onSuccess('You have created a token with this API key')
          }
        } else {
          this.props.onError('There is no API key available')
        }
      })
    }
  }

  generateToken = () => {
    const { currentStoreKey } = this.state
    const { shopDispatch = {} } = this.props

    if (shopDispatch && shopDispatch.companyId && shopDispatch.shopId) {
      //mcs - create credential
      const request = {
        companyId: shopDispatch.companyId,
        shopId: shopDispatch.shopId,
        apiKey: currentStoreKey,
      }
      this.props.dispatch(createDCHCredentials({ provider: 'wmDispatch', request })).then((res) => {
        if (res && res.accessToken != null) {
          this.props.dispatch(setWmDispatchCretendial(res))
          this.props.onSuccess('Token successfully generated')
          this.setState({
            currentAccessToken: res.accessToken,
            currentExpirationDate: res.expirationDate,
            generateNewToken: false,
          })
        } else {
          this.props.onError('Fail generating the access token')
        }
      })
    }
  }

  renewToken = () => {
    const { currentStoreKey } = this.state
    const { shopDispatch = {} } = this.props

    if (shopDispatch && shopDispatch.companyId && shopDispatch.shopId) {
      //mcs - renew credentials token
      const request = {
        companyId: shopDispatch.companyId,
        shopId: shopDispatch.shopId,
        apiKey: currentStoreKey,
      }
      this.props.dispatch(getDCHRenewToken({ provider: 'wmDispatch', request })).then((res) => {
        if (res && res.accessToken != null) {
          this.props.dispatch(setWmDispatchCretendial(res))
          this.props.onSuccess('Token successfully renewed')
          this.setState({
            currentAccessToken: res.accessToken,
            currentExpirationDate: res.expirationDate,
          })
        } else {
          this.props.onError('Fail renewing the access token')
        }
      })
    }
  }

  toggleEditApiKey = () => {
    this.setState({
      editModeApiKey: !this.state.editModeApiKey,
      currentStoreKey: (this.props.shopCredential && this.props.shopCredential.apiKey) || '',
    })
    this.resetApiKeyFlags()
  }

  onUpdateApiKey = () => {
    const { currentStoreKey } = this.state
    const { shopDispatch = {} } = this.props

    if (currentStoreKey == '' || /^( )*$/.test(currentStoreKey)) {
      this.props.onError('API key value must not be empty')
      return
    }

    if (shopDispatch && shopDispatch.companyId && shopDispatch.shopId) {
      const request = {
        companyId: shopDispatch.companyId,
        shopId: shopDispatch.shopId,
        apiKey: currentStoreKey,
      }

      this.props.dispatch(updateDCHCredentials({ request, provider: 'wmDispatch' })).then((res) => {
        this.props
          .dispatch(
            getDCHCredentialByShopId({
              companyId: shopDispatch.companyId,
              shopId: shopDispatch.shopId,
              provider: 'wmDispatch',
            }),
          )
          .then((res) => {
            this.toggleEditApiKey()
          })
      })
    }
  }

  toggleEdit = () => {
    this.setState({
      editMode: !this.state.editMode,
      enableStatus:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enabled) ||
        false,
      enableAllEmptyOrders:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableAllowEmptyOrders) ||
        false,
      enable2WayAssignment:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableTwoWayAssignment) ||
        false,
      enable2WayUpdateSchedule:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableTwoWayUpdateSchedule) ||
        false,
      enable2WaySendtoUnassign:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableTwoWayRevert) ||
        false,
      enable2WayAutopack:
        (this.props.shopDispatch && this.props.shopDispatch.wmDispatchSettings.enableTwoAutoPack) ||
        false,
      enableUnassignedOrder:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableUnAssignedOrder) ||
        false,
      colorSameDay:
        this.props.shopDispatch &&
        this.props.shopDispatch.wmDispatchSettings &&
        this.props.shopDispatch.wmDispatchSettings.colorSameDay != ''
          ? this.props.shopDispatch.wmDispatchSettings.colorSameDay
          : '#E89623',
      colorNextDay:
        this.props.shopDispatch &&
        this.props.shopDispatch.wmDispatchSettings &&
        this.props.shopDispatch.wmDispatchSettings.colorNextDay != ''
          ? this.props.shopDispatch.wmDispatchSettings.colorNextDay
          : '#9500DB',
      colorBeyondNextDay:
        this.props.shopDispatch &&
        this.props.shopDispatch.wmDispatchSettings &&
        this.props.shopDispatch.wmDispatchSettings.colorBeyondNextDay != ''
          ? this.props.shopDispatch.wmDispatchSettings.colorBeyondNextDay
          : '#1cc4e8',
      enabledScheduledColoredPins:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enabledScheduledColoredPins) ||
        false,
      enableSubTotal:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableSubTotal) ||
        false,
      enableApplicableDiscountAmount:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableApplicableDiscountAmount) ||
        false,
      enableApplicableExciseTaxes:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableApplicableExciseTaxes) ||
        false,
      enableTotalTaxORGranularTax:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableTotalTaxORGranularTax) ||
        false,
      enableApplicablePromotionsName:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableApplicablePromotionsName) ||
        false,
      enableApplicableRewardsName:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableApplicableRewardsName) ||
        false,
      enableApplicableOrderTags:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableApplicableOrderTags) ||
        false,
      enablePaidStatus:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enablePaidStatus) ||
        false,
      enableProductName:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableProductName) ||
        false,
      enableBrand:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableBrand) ||
        false,
      enableProductsValue:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableProductsValue) ||
        false,
      enableDiscount:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableDiscount) ||
        false,
      enableDiscountNotes:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableDiscountNotes) ||
        false,
      enableWPU:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableWPU) ||
        false,
      enableProductSKU:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableProductSKU) ||
        false,
      enableBatchUID:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableBatchUID) ||
        false,
      enableBatchTrackingSystemLabel:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableBatchTrackingSystemLabel) ||
        false,
      enableMemberId:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableMemberId) ||
        false,
      enableMemberGroup:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableMemberGroup) ||
        false,
      enableMemberTags:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableMemberTags) ||
        false,
      enableConsumerType:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableConsumerType) ||
        false,
      enableDOB:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableDOB) ||
        false,
      enableJoinedDate:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableJoinedDate) ||
        false,
      enableLastVisitDate:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableLastVisitDate) ||
        false,
      enableNumberOfCompletedTransactions:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableNumberOfCompletedTransactions) ||
        false,
      enableTotalLoyaltyPoints:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableTotalLoyaltyPoints) ||
        false,
      enableEstimatedPointsEarnedOnOrder:
        (this.props.shopDispatch &&
          this.props.shopDispatch.wmDispatchSettings &&
          this.props.shopDispatch.wmDispatchSettings.enableEstimatedPointsEarnedOnOrder) ||
        false,
    })
  }

  onUpdate = () => {
    this.updateSettingInfo()
  }

  updateSettingInfo() {
    const {
      enableStatus,
      enableAllEmptyOrders,
      enable2WayAssignment,
      enable2WayUpdateSchedule,
      enable2WaySendtoUnassign,
      enable2WayAutopack,
      enableUnassignedOrder,
      colorSameDay,
      colorNextDay,
      colorBeyondNextDay,
      currentStoreKey,
      enabledScheduledColoredPins,
      enableSubTotal,
      enableApplicableDiscountAmount,
      enableApplicableExciseTaxes,
      enableTotalTaxORGranularTax,
      enableApplicablePromotionsName,
      enableApplicableRewardsName,
      enableApplicableOrderTags,
      enablePaidStatus,
      enableProductName,
      enableBrand,
      enableProductsValue,
      enableDiscount,
      enableDiscountNotes,
      enableWPU,
      enableProductSKU,
      enableBatchUID,
      enableBatchTrackingSystemLabel,
      enableMemberId,
      enableMemberGroup,
      enableMemberTags,
      enableConsumerType,
      enableDOB,
      enableJoinedDate,
      enableLastVisitDate,
      enableNumberOfCompletedTransactions,
      enableTotalLoyaltyPoints,
      enableEstimatedPointsEarnedOnOrder,
    } = this.state
    const { shopDispatch = {} } = this.props
    shopDispatch.wmDispatchSettings.apiKey = currentStoreKey
    shopDispatch.wmDispatchSettings.enabled = enableStatus
    shopDispatch.wmDispatchSettings.enableAllowEmptyOrders = enableAllEmptyOrders
    shopDispatch.wmDispatchSettings.enableTwoWayAssignment = enable2WayAssignment
    shopDispatch.wmDispatchSettings.enableTwoWayUpdateSchedule = enable2WayUpdateSchedule
    shopDispatch.wmDispatchSettings.enableTwoWayRevert = enable2WaySendtoUnassign
    shopDispatch.wmDispatchSettings.enableTwoAutoPack = enable2WayAutopack
    shopDispatch.wmDispatchSettings.enableUnAssignedOrder = enableUnassignedOrder
    shopDispatch.wmDispatchSettings.colorSameDay = colorSameDay
    shopDispatch.wmDispatchSettings.colorNextDay = colorNextDay
    shopDispatch.wmDispatchSettings.colorBeyondNextDay = colorBeyondNextDay
    shopDispatch.wmDispatchSettings.enabledScheduledColoredPins = enabledScheduledColoredPins
    //Order Notes
    shopDispatch.wmDispatchSettings.enableSubTotal = enableSubTotal
    shopDispatch.wmDispatchSettings.enableApplicableDiscountAmount = enableApplicableDiscountAmount
    shopDispatch.wmDispatchSettings.enableApplicableExciseTaxes = enableApplicableExciseTaxes
    shopDispatch.wmDispatchSettings.enableTotalTaxORGranularTax = enableTotalTaxORGranularTax
    shopDispatch.wmDispatchSettings.enableApplicablePromotionsName = enableApplicablePromotionsName
    shopDispatch.wmDispatchSettings.enableApplicableRewardsName = enableApplicableRewardsName
    shopDispatch.wmDispatchSettings.enableApplicableOrderTags = enableApplicableOrderTags
    shopDispatch.wmDispatchSettings.enablePaidStatus = enablePaidStatus
    //Order Notes - Product
    shopDispatch.wmDispatchSettings.enableProductName = enableProductName
    shopDispatch.wmDispatchSettings.enableBrand = enableBrand
    shopDispatch.wmDispatchSettings.enableProductsValue = enableProductsValue
    shopDispatch.wmDispatchSettings.enableDiscount = enableDiscount
    shopDispatch.wmDispatchSettings.enableDiscountNotes = enableDiscountNotes
    shopDispatch.wmDispatchSettings.enableWPU = enableWPU
    shopDispatch.wmDispatchSettings.enableProductSKU = enableProductSKU
    shopDispatch.wmDispatchSettings.enableBatchUID = enableBatchUID
    shopDispatch.wmDispatchSettings.enableBatchTrackingSystemLabel = enableBatchTrackingSystemLabel
    //Member Notes
    shopDispatch.wmDispatchSettings.enableMemberId = enableMemberId
    shopDispatch.wmDispatchSettings.enableMemberGroup = enableMemberGroup
    shopDispatch.wmDispatchSettings.enableMemberTags = enableMemberTags
    shopDispatch.wmDispatchSettings.enableConsumerType = enableConsumerType
    shopDispatch.wmDispatchSettings.enableDOB = enableDOB
    shopDispatch.wmDispatchSettings.enableJoinedDate = enableJoinedDate
    shopDispatch.wmDispatchSettings.enableLastVisitDate = enableLastVisitDate
    shopDispatch.wmDispatchSettings.enableNumberOfCompletedTransactions =
      enableNumberOfCompletedTransactions
    shopDispatch.wmDispatchSettings.enableTotalLoyaltyPoints = enableTotalLoyaltyPoints
    shopDispatch.wmDispatchSettings.enableEstimatedPointsEarnedOnOrder =
      enableEstimatedPointsEarnedOnOrder

    this.props
      .dispatch(updateDCHSettings({ request: shopDispatch, provider: 'wmDispatch' }))
      .then((res) => {
        this.props.dispatch(getDCHSettingsByCompanyId(shopDispatch.companyId)).then((res) => {
          this.toggleEdit()
        })
      })
  }

  hideToken(token) {
    if (token == null || token == '' || token == undefined) return ''
    return '...' + token.substr(-30, 30)
  }

  render() {
    const {
      editMode = {},
      editModeApiKey = false,
      enableStatus = false,
      enableAllEmptyOrders = false,
      enable2WayAssignment = false,
      enable2WayUpdateSchedule = false,
      enable2WaySendtoUnassign = false,
      enable2WayAutopack = false,
      enableUnassignedOrder = false,
      colorSameDay,
      colorNextDay,
      colorBeyondNextDay,
      currentStoreKey,
      currentAccessToken,
      currentExpirationDate = '',
      generateNewToken = false,
      enabledColoredPins = false,
      enabledScheduledColoredPins = false,
      enableTwoWay = false,
      changedApiKey = false,
      enableSubTotal = false,
      enableApplicableDiscountAmount = false,
      enableApplicableExciseTaxes = false,
      enableTotalTaxORGranularTax = false,
      enableApplicablePromotionsName = false,
      enableApplicableRewardsName = false,
      enableApplicableOrderTags = false,
      enablePaidStatus = false,
      enableProductName = false,
      enableBrand = false,
      enableProductsValue = false,
      enableDiscount = false,
      enableDiscountNotes = false,
      enableWPU = false,
      enableProductSKU = false,
      enableBatchUID = false,
      enableBatchTrackingSystemLabel = false,
      enableMemberId = false,
      enableMemberGroup = false,
      enableMemberTags = false,
      enableConsumerType = false,
      enableDOB = false,
      enableJoinedDate = false,
      enableLastVisitDate = false,
      enableNumberOfCompletedTransactions = false,
      enableTotalLoyaltyPoints = false,
      enableEstimatedPointsEarnedOnOrder = false,
    } = this.state

    let dateParsed = ''
    if (currentExpirationDate) {
      dateParsed = toLocalDate(currentExpirationDate, 'MM/DD/YYYY')
    }
    const {
      shopInfo,
      enableAddShop,
      operAddShopModal,
      cancelShop,
      shopsList,
      shopDispatch,
      settingsList,
    } = this.props
    return (
      <div>
        {enableAddShop && (
          <AddShop
            operAddShopModal={operAddShopModal}
            cancelShop={cancelShop}
            shopsList={shopsList}
            settingsList={settingsList}
          />
        )}
        <Grid container className="listing-spacing">
          {!enableAddShop && (
            <ListItem>
              <Grid container>
                <Grid className="labelField" item xs={12} sm={8} md={8} lg={8}>
                  <Typography variant="title">{(shopInfo && shopInfo.name) || ''}</Typography>
                </Grid>
              </Grid>
            </ListItem>
          )}
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={12} sm={8} md={8} lg={8}>
                <Grid container direction="row">
                  <Grid item xs={12} sm={5} md={5} lg={5} style={{ paddingTop: '18px' }}>
                    <div style={{ marginBottom: 3 }}>WM Dispatch API Key</div>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6} style={{ paddingTop: '12px' }}>
                    <EditableInput
                      editMode={true}
                      material={false}
                      value={(!enableAddShop && currentStoreKey) || ''}
                      onChange={(value) => this.onChangeApiKey('currentStoreKey', value)}
                      valueToRender={(!enableAddShop && currentStoreKey) || ''}
                      placeholder="WM Dispatch API Key"
                      disabled={!editModeApiKey}
                    />
                  </Grid>
                </Grid>
              </Grid>
              {!enableAddShop && (
                <Grid item xs={12} sm={4} md={4} lg={4} style={{ paddingTop: '8px' }}>
                  <div>
                    {!editModeApiKey ? (
                      <Button
                        className="primary-button margin btn-border"
                        onClick={this.toggleEditApiKey}
                      >
                        {' '}
                        Update{' '}
                      </Button>
                    ) : (
                      <div>
                        <Button
                          onClick={this.checkApiKey}
                          className="primary-button margin btn-border"
                        >
                          Check API Key
                        </Button>
                        <Button
                          onClick={this.onUpdateApiKey}
                          disabled={!changedApiKey}
                          className="primary-button margin btn-border"
                        >
                          Save
                        </Button>
                        <Button
                          className="danger-button margin btn-border"
                          onClick={this.toggleEditApiKey}
                        >
                          Cancel
                        </Button>
                      </div>
                    )}
                  </div>
                </Grid>
              )}
            </Grid>
          </ListItem>
          <ListItem style={{ paddingTop: '0px' }}>
            <Grid container>
              <Grid className="labelField" item xs={12} sm={8} md={8} lg={8}>
                <Grid container direction="row">
                  <Grid item xs={12} sm={5} md={5} lg={5} style={{ paddingTop: '18px' }}>
                    <div style={{ marginBottom: 1 }}>Access Token</div>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6} style={{ paddingTop: '12px' }}>
                    <EditableInput
                      editMode={true}
                      material={false}
                      value={
                        (!enableAddShop &&
                          currentAccessToken &&
                          this.hideToken(currentAccessToken)) ||
                        ''
                      }
                      onChange={(value) => this.onChange('currentAccessToken', value)}
                      valueToRender={(!enableAddShop && currentAccessToken) || ''}
                      placeholder="Access Token"
                      disabled={true}
                    />
                    {dateParsed ? (
                      <p style={{ color: 'lightgrey' }}>Expiration Date: {dateParsed}</p>
                    ) : null}
                  </Grid>
                </Grid>
              </Grid>
              {!enableAddShop && (
                <Grid item xs={12} sm={4} md={4} lg={4} style={{ paddingTop: '8px' }}>
                  <div>
                    {this.props.shopCredential &&
                      this.props.shopCredential.apiKey != '' &&
                      (generateNewToken ? (
                        <Button
                          disabled={editModeApiKey}
                          onClick={this.generateToken}
                          className="primary-button margin btn-border"
                        >
                          Generate Token
                        </Button>
                      ) : (
                        <Button
                          disabled={editModeApiKey}
                          onClick={this.renewToken}
                          className="primary-button margin btn-border"
                        >
                          Renew Token
                        </Button>
                      ))}
                  </div>
                </Grid>
              )}
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={12} sm={8} md={8} lg={8}>
                <Typography
                  variant="subheading"
                  style={{ marginTop: '20px', marginBottom: '10px' }}
                >
                  <b>Settings</b>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4} md={4} lg={4}>
                {!enableAddShop &&
                  (!editMode ? (
                    <Button className="primary-button margin btn-border" onClick={this.toggleEdit}>
                      {' '}
                      Edit{' '}
                    </Button>
                  ) : (
                    <div className="margin-bottom-small">
                      <Button className="primary-button margin btn-border" onClick={this.onUpdate}>
                        Save
                      </Button>
                      <Button className="danger-button margin btn-border" onClick={this.toggleEdit}>
                        Cancel
                      </Button>
                    </div>
                  ))}
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField txt-bold" item xs={12} sm={8} md={8} lg={8}>
                <Typography>Status</Typography>
              </Grid>
              <Grid className="editField" item xs={12} sm={4} md={4} lg={4}>
                <Typography>
                  <EditableSwitch
                    checked={enableStatus}
                    onChange={this.onChange('enableStatus', enableStatus)}
                    valueToRender={enableStatus ? 'Enabled' : 'Disabled'}
                    editMode={editMode}
                  />
                </Typography>
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField txt-bold" item xs={12} sm={8} md={8} lg={8}>
                <Typography>Allow Empty Orders</Typography>
              </Grid>
              <Grid className="editField" item xs={12} sm={4} md={4} lg={4}>
                <Typography>
                  <EditableSwitch
                    checked={enableAllEmptyOrders}
                    onChange={this.onChange('enableAllEmptyOrders', enableAllEmptyOrders)}
                    valueToRender={enableAllEmptyOrders ? 'Enabled' : 'Disabled'}
                    editMode={editMode}
                  />
                </Typography>
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField txt-bold" item xs={12} sm={8} md={8} lg={8}>
                <Typography>Enable Unassigned WM Dispatch Order</Typography>
              </Grid>
              <Grid className="editField" item xs={12} sm={4} md={4} lg={4}>
                <Typography>
                  <EditableSwitch
                    checked={enableUnassignedOrder}
                    onChange={this.onChange('enableUnassignedOrder', enableUnassignedOrder)}
                    valueToRender={enableUnassignedOrder ? 'Enabled' : 'Disabled'}
                    editMode={editMode}
                  />
                </Typography>
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField txt-bold" item xs={12} sm={8} md={8} lg={8}>
                <Typography>2-Way | Assign Orders</Typography>
              </Grid>
              <Grid className="editField" item xs={12} sm={3} md={3} lg={3}>
                <Typography>
                  <EditableSwitch
                    checked={enable2WayAssignment}
                    onChange={this.onChange('enable2WayAssignment', enable2WayAssignment)}
                    valueToRender={
                      !enableTwoWay ? 'Unavailable' : enable2WayAssignment ? 'Enabled' : 'Disabled'
                    }
                    editMode={enableTwoWay && editMode}
                  />
                </Typography>
              </Grid>
              <Grid className="editField" item xs={12} sm={1} md={1} lg={1}>
                {tooltipWmDispatch(
                  'If enabled, allow WM Dispatch to communicate with BLAZE. Please reach out to BLAZE Support if option is "Unavailable"',
                )}
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField txt-bold" item xs={12} sm={8} md={8} lg={8}>
                <Typography>2-Way | Unassign Orders</Typography>
              </Grid>
              <Grid className="editField" item xs={12} sm={3} md={3} lg={3}>
                <Typography>
                  <EditableSwitch
                    checked={enable2WaySendtoUnassign}
                    onChange={this.onChange('enable2WaySendtoUnassign', enable2WaySendtoUnassign)}
                    valueToRender={
                      !enableTwoWay
                        ? 'Unavailable'
                        : enable2WaySendtoUnassign
                        ? 'Enabled'
                        : 'Disabled'
                    }
                    editMode={enableTwoWay && editMode}
                  />
                </Typography>
              </Grid>
              <Grid className="editField" item xs={12} sm={1} md={1} lg={1}>
                {tooltipWmDispatch(
                  'If enabled, send to "Unassigned," if assignment from WM Dispatch fails. Please reach out to BLAZE Support if option is "Unavailable"',
                )}
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField txt-bold" item xs={12} sm={8} md={8} lg={8}>
                <Typography>2-Way | Update Schedule Time</Typography>
              </Grid>
              <Grid className="editField" item xs={12} sm={3} md={3} lg={3}>
                <Typography>
                  <EditableSwitch
                    checked={enable2WayUpdateSchedule}
                    onChange={this.onChange('enable2WayUpdateSchedule', enable2WayUpdateSchedule)}
                    valueToRender={
                      !enableTwoWay
                        ? 'Unavailable'
                        : enable2WayUpdateSchedule
                        ? 'Enabled'
                        : 'Disabled'
                    }
                    editMode={enableTwoWay && editMode}
                  />
                </Typography>
              </Grid>
              <Grid className="editField" item xs={12} sm={1} md={1} lg={1}>
                {tooltipWmDispatch(
                  'If enabled, allow WM Dispatch to update scheduled time. Please reach out to BLAZE Support if option is "Unavailable"',
                )}
              </Grid>
            </Grid>
          </ListItem>
          {/*<ListItem>
                        <Grid container>
                            <Grid className="labelField txt-bold" item xs={12} sm={8} md={8} lg={8}>
                                <Typography>
                                2-Way | Auto-pack Orders
                                </Typography>
                            </Grid>
                            <Grid className="editField" item xs={12} sm={3} md={3} lg={3}>
                                <Typography>
                                    <EditableSwitch
                                        checked={enable2WayAutopack}
                                        onChange={this.onChange('enable2WayAutopack', enable2WayAutopack)}
                                        valueToRender={enableTwoWay == false ? "Unavailable" : (enable2WayAutopack ? 'Enabled' : 'Disabled')}
                                        editMode={enableTwoWay && editMode}
                                    />
                                </Typography>
                            </Grid>
                            <Grid className="editField" item xs={12} sm={1} md={1} lg={1}>
                                {tooltipWmDispatch('If enabled, auto set the packed information if order is unpacked. The assigned driver would be the packer. Please reach out to BLAZE Support if option is "Unavailable"')}
                            </Grid>
                        </Grid>
                    </ListItem> */}
          {/* 
                    <Typography variant="subheading" style={{marginTop: "20px", marginBottom: "20px"}}>
                        <b>Other Settings</b>
                    </Typography>
                    <ListItem>
                        <Grid container>
                            <Grid className="labelField txt-bold" item xs={12} sm={8} md={8} lg={8}>
                                <Typography>
                                    {!enabledColoredPins? "Enable Colored Pin" : "Scheduled Colored Pins"}
                                </Typography>
                            </Grid>
                            <Grid className="editField" item xs={12} sm={4} md={4} lg={4}>
                                <Typography>
                                    <EditableSwitch
                                        checked={enabledScheduledColoredPins}
                                        onChange={this.onChange('enabledScheduledColoredPins', enabledScheduledColoredPins)}
                                        valueToRender={enabledColoredPins == false? 'Unavailable' :(enabledScheduledColoredPins ? 'Enabled' : 'Disabled')}
                                        editMode={enabledColoredPins && editMode}
                                    />
                                </Typography>
                            </Grid>
                        </Grid>
                    </ListItem>
                    { enabledColoredPins && enabledScheduledColoredPins && <ListItem>
                        <Grid container>
                            <Grid className="labelField" item xs={12} sm={8} md={8} lg={8}>
                            Same Day Delivery
                        </Grid>
                            <Grid className="editField" item xs={12} sm={4} md={4} lg={4}>
                                <EditableColorPicker
                                    valueToRender={<ColorSwatch color={colorSameDay} />}
                                    color={colorSameDay}
                                    onColorChange={this.onChangeColor('colorSameDay')}
                                    editMode={editMode}
                                    changePosition={true}
                                />
                            </Grid>
                        </Grid>
                    </ListItem>}
                    { enabledColoredPins && enabledScheduledColoredPins && <ListItem>
                        <Grid container>
                            <Grid className="labelField" item xs={12} sm={8} md={8} lg={8}>
                            Next Day Delivery
                        </Grid>
                            <Grid className="editField" item xs={12} sm={4} md={4} lg={4}>
                                <EditableColorPicker
                                    valueToRender={<ColorSwatch color={colorNextDay} />}
                                    color={colorNextDay}
                                    onColorChange={this.onChangeColor('colorNextDay')}
                                    editMode={editMode}
                                    changePosition={true}
                                />
                            </Grid>
                        </Grid>
                    </ListItem>}
                    { enabledColoredPins && enabledScheduledColoredPins && <ListItem>
                        <Grid container>
                            <Grid className="labelField" item xs={12} sm={8} md={8} lg={8}>
                            Beyond Next Day Delivery
                        </Grid>
                        <Grid className="editField" item xs={12} sm={4} md={4} lg={4}>
                            <EditableColorPicker
                                valueToRender={<ColorSwatch color={colorBeyondNextDay } />}
                                color={colorBeyondNextDay }
                                onColorChange={this.onChangeColor('colorBeyond')}
                                editMode={editMode}
                                changePosition={true}
                            />
                        </Grid>
                        </Grid>
                    </ListItem>}
                */}
          <Typography variant="subheading" style={{ marginTop: '20px', marginBottom: '20px' }}>
            <b>Order Notes</b>
          </Typography>
          <SwitchSettings
            title={'Subtotal'}
            editMode={editMode}
            settingValue={enableSubTotal}
            settingName={'enableSubTotal'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title={'Applicable Discount Amount'}
            editMode={editMode}
            settingValue={enableApplicableDiscountAmount}
            settingName={'enableApplicableDiscountAmount'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title={'Applicable Excise Taxes'}
            editMode={editMode}
            settingValue={enableApplicableExciseTaxes}
            settingName={'enableApplicableExciseTaxes'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title={'Total Tax'}
            editMode={editMode}
            settingValue={enableTotalTaxORGranularTax}
            settingName={'enableTotalTaxORGranularTax'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title={'Applicable Promotion Name(s)'}
            editMode={editMode}
            settingValue={enableApplicablePromotionsName}
            settingName={'enableApplicablePromotionsName'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title={'Applicable Reward Name(s)'}
            editMode={editMode}
            settingValue={enableApplicableRewardsName}
            settingName={'enableApplicableRewardsName'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title={'Applicable Order Tags'}
            editMode={editMode}
            settingValue={enableApplicableOrderTags}
            settingName={'enableApplicableOrderTags'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title={'Paid Status'}
            editMode={editMode}
            settingValue={enablePaidStatus}
            settingName={'enablePaidStatus'}
            onChange={this.onChange}
          />
          <Typography variant="subheading" style={{ marginTop: '20px', marginBottom: '20px' }}>
            <b>Product Info</b>
          </Typography>
          <SwitchSettings
            title="Name"
            editMode={editMode}
            settingValue={enableProductName}
            settingName={'enableProductName'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title="Brand"
            editMode={editMode}
            settingValue={enableBrand}
            settingName={'enableBrand'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title="Price"
            editMode={editMode}
            settingValue={enableProductsValue}
            settingName={'enableProductsValue'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title="Discount"
            editMode={editMode}
            settingValue={enableDiscount}
            settingName={'enableDiscount'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title="Discount Notes"
            editMode={editMode}
            settingValue={enableDiscountNotes}
            settingName={'enableDiscountNotes'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title="WPU"
            editMode={editMode}
            settingValue={enableWPU}
            settingName={'enableWPU'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title="SKU"
            editMode={editMode}
            settingValue={enableProductSKU}
            settingName={'enableProductSKU'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title="Unique #"
            editMode={editMode}
            settingValue={enableBatchUID}
            settingName={'enableBatchUID'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title="Batch Tracking System Tag"
            editMode={editMode}
            settingValue={enableBatchTrackingSystemLabel}
            settingName={'enableBatchTrackingSystemLabel'}
            onChange={this.onChange}
          />
          <Typography variant="subheading" style={{ marginTop: '20px', marginBottom: '20px' }}>
            <b>Member Notes</b>
          </Typography>
          <SwitchSettings
            title="Member ID"
            editMode={editMode}
            settingValue={enableMemberId}
            settingName={'enableMemberId'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title="Member Group"
            editMode={editMode}
            settingValue={enableMemberGroup}
            settingName={'enableMemberGroup'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title="Member Tags"
            editMode={editMode}
            settingValue={enableMemberTags}
            settingName={'enableMemberTags'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title="Consumer Type"
            editMode={editMode}
            settingValue={enableConsumerType}
            settingName={'enableConsumerType'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title="DOB"
            editMode={editMode}
            settingValue={enableDOB}
            settingName={'enableDOB'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title="Joined Date"
            editMode={editMode}
            settingValue={enableJoinedDate}
            settingName={'enableJoinedDate'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title="Last Visit Date"
            editMode={editMode}
            settingValue={enableLastVisitDate}
            settingName={'enableLastVisitDate'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title="Number of Completed Transactions"
            editMode={editMode}
            settingValue={enableNumberOfCompletedTransactions}
            settingName={'enableNumberOfCompletedTransactions'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title="Total Loyalty Points"
            editMode={editMode}
            settingValue={enableTotalLoyaltyPoints}
            settingName={'enableTotalLoyaltyPoints'}
            onChange={this.onChange}
          />
          <SwitchSettings
            title="Estimated Points Earned on order"
            editMode={editMode}
            settingValue={enableEstimatedPointsEarnedOnOrder}
            settingName={'enableEstimatedPointsEarnedOnOrder'}
            onChange={this.onChange}
          />
          {!enableAddShop && (
            <Grid container>
              <Grid item xs={12} sm={9} md={9} lg={9} style={{ textAlign: 'center' }}>
                <Button onClick={this.openDeleteShopModal} className="deleteIntegration">
                  {' '}
                  Delete Integration{' '}
                </Button>
              </Grid>
            </Grid>
          )}
        </Grid>
        <ModalDialog
          title={'Delete Shop'}
          ref={(c) => (this.shopDeleteModal = c)}
          onConfirm={() => this.deleteIntegration(shopDispatch)}
          confirmText="Confirm"
        >
          <div> Are you sure you want to delete this shop? </div>
        </ModalDialog>
      </div>
    )
  }
}
const WmDispatchShopInfoSettingsConnected = connect(
  ({ shopReducer, integrationReducer, dispatch }) => ({
    shopReducer,
    integrationReducer,
    dispatch,
  }),
)(WmDispatchShopInfoSettings)
export default withRouter(WmDispatchShopInfoSettingsConnected)



// WEBPACK FOOTER //
// ./src/components/WmDispatch/WmDispatchShopInfoSettings.js